import React from 'react'
import styles from '../PlayerAccountView.module.css'
import classNames from 'classnames'
import { PlayerAccountCard } from './PlayerAccountCard'
import { TPlayerGameCard } from '../../../types/commonTypes'
import { useFadeAnimation } from '../../../hooks/FadeAnimation/useFadeAnimation'

type PlayerAccountGamesGridProps = {
  games: TPlayerGameCard[]
  loading: boolean
}

export const PlayerAccountGamesGrid: React.FC<PlayerAccountGamesGridProps> = ({ games, loading }) => {
  const { fadeTransition } = useFadeAnimation(loading, true)

  return (
    <>
      <div className={classNames(styles.gridContainer, fadeTransition)}>
        {games.map((game, index) => {
          return <PlayerAccountCard key={`${game.id}${index}`} game={game} disabled={!game.open} />
        })}
      </div>
    </>
  )
}
